import { render, staticRenderFns } from "./RegistrationCodeForm.vue?vue&type=template&id=c8ac3018&"
import script from "./RegistrationCodeForm.vue?vue&type=script&lang=ts&"
export * from "./RegistrationCodeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports